import React from "react";
import FooterContact from "./FooterContact";
import FooterNavigation from "./FooterNavigation";
import FooterStaticLinks from "./FooterStaticLinks";

export default function Footer() {
  return (
    <React.Fragment>
      <FooterNavigation />
      <div className="pt-0 py-5 bg-black">
        <FooterContact />
      </div>
      {/* <FooterStaticLinks /> */}
    </React.Fragment>
  );
}
